<app-landing-header></app-landing-header>
<app-favorite-course-widget></app-favorite-course-widget>
<app-course-carousel selector="newcourses"></app-course-carousel>
<app-course-carousel selector="trendingcourses"></app-course-carousel>
<app-landing-ce-socials></app-landing-ce-socials>
<app-course-carousel selector="newethics"></app-course-carousel>
